module.exports = __webpack_public_path__ + "static/media/Version.4622876a.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 126
// module chunks = 1